<template>
  <div id="app" ref="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
        this.$refs.app.scrollTop = 0
      })
    },
    linkNowPage(){
        let path = this.$route.path
        let dontJump = ['/privacy-policy', '/terms-conditions', '/beny-fuel-offer-terms-and-conditions']
        if(Utils._isMobile() && dontJump.indexOf(path) === -1){
            window.location.replace('https://mobile.beny.com.au/#/home')
            // window.location.replace('https://mobile.beny.com.au/#/home')
        }
    }
  },
  mounted() {
    this.linkNowPage()
    window.addEventListener('resize',this.linkNowPage)
  },
  unmounted(){
    window.removeEventListener('resize',this.linkNowPage)
  }
}
</script>

<style>
#app {
  /* min-width: 1340px; */
  min-height: 100vh;
  background: #F8F9FD;
}
body{
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue